import cx from 'classnames';
import { useState, useEffect } from 'react';
import { PortknoxPlans } from '@portknox_net/portknox-prices';
import { useIntl } from 'react-intl';
import { MODE_WEBSITE } from '../../../consts';

const View = (props) => {
  const { data, className, style } = props;
  const intl = useIntl();
  const [currentView, setCurrentView] = useState('plans');

  // Hide other blocks when in checkout views
  useEffect(() => {
    const shouldHideOthers = [
      'order_confirm',
      'form_invoice_address',
      'form_payment',
    ].includes(currentView);

    if (shouldHideOthers) {
      document.body.classList.add('portknox-checkout-active');
    } else {
      document.body.classList.remove('portknox-checkout-active');
    }

    return () => {
      document.body.classList.remove('portknox-checkout-active');
    };
  }, [currentView]);

  // Get PayPal Client ID from block data or fall back to environment variable
  let paypalClientId = data?.paypalClientId;
  if (!paypalClientId) {
    if (__CLIENT__) {
      paypalClientId = window.env?.RAZZLE_PAYPAL_CLIENT_ID;
    } else {
      paypalClientId = process.env.RAZZLE_PAYPAL_CLIENT_ID;
    }
  }

  // Get mode from block data or use default
  const mode = data?.mode || MODE_WEBSITE;

  return (
    <div className={cx('block', 'portknoxplans', className)} style={style}>
      <div className="block-container">
        {(data?.title || data?.description) && (
          <div style={{ marginBottom: '2rem' }}>
            {data?.title && (
              <h2 className="documentFirstHeading">{data.title}</h2>
            )}
            {data?.description && <p>{data.description}</p>}
          </div>
        )}
        <PortknoxPlans
          mode={mode}
          paypalClientId={paypalClientId}
          lang={intl.locale}
          onViewChange={setCurrentView}
        />
      </div>
    </div>
  );
};

export default View;
